import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class LanguageLevel extends Mappeable {

    idTypeLevelPk: number;
    txtTypeLevelLanguage: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtTypeLevelLanguage: this.txtTypeLevelLanguage,
            mrkActive: this.mrkActive,
        }
    }

}